/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
window.defaultTimeZone = "Z-03:00";

const a00 = require("./public/template/pbds/loader.css");

/*
// novo template
const a00 = require("./public/template/pbstrap/loader.css");

//const aa00 = require("./public/template/fonts.css");
const bootstrapCss = require("bootstrap/dist/css/bootstrap.min.css");
const pb00 = require("./public/template/vars.css");
const pb01 = require("./public/template/pb.css");
const pb02 = require("./public/template/pb-common.css");
const pb03 = require("./public/template/pb-contents.css");

const pb04 = require("./public/template/pb-specifier.css");
const pb05 = require("./public/template/pb-experience.css");
const pb06 = require("./public/template/pb-virtual.css");
//const pb07 = require("./public/template/pb-downloads.css");
const pb08 = require("./public/template/pb-calculator.css");
//const pb09 = require("./public/template/pb-contact.css");
//const pb10 = require("./public/template/pb-maisarquitetura.css");
//const pb11 = require("./public/template/pb-lastras.css");
const pb12 = require("./public/template/pb-careers.css");
const pb13 = require("./public/template/pb-fachada.css");
const pb14 = require("./public/template/pb-about.css");
const pb15 = require("./public/template/pb-sustainability.css");
const pb16 = require("./public/template/pb-innovation.css");
const pb17 = require("./public/template/pb-terms.css");
const pb18 = require("./public/template/pb-releases.css");
const pb19 = require("./public/template/pb-officina.css");
const pb20 = require("./public/template/pb-pattern.css");
const pb21 = require("./public/template/pb-engineers.css");
const pb22 = require("./public/template/pb-international.css");
//const pb23 = require("./public/template/pb-consent.css");
const pb24 = require("./public/template/pb-sympathetic.css");
const pb25 = require("./public/template/pb-porcelanateria.css");
const pb26 = require("./public/template/pb-help.css");
const pb27 = require("./public/template/pb-tracking.css");
const pb28 = require("./public/template/pb-franchise.css");
const pb29 = require("./public/template/pb-favorites-v2.css");
const pb30 = require("./public/template/pb-helpcenter.css");
const pb31 = require("./public/template/pb-discontinued.css");
const pb32 = require("./public/template/pb-images.css");
//const pb32 = require("./public/data/lead/lead.css");
const pb33 = require("./public/template/pb-toasts.css");

const pb99 = require("./public/template/tweaks.css");
const pb997 = require("./public/template/sandbox.css");
const pb998 = require("./public/template/pbstrap/temptweaks.css");
const pb999 = require("./public/template/postfix.css");
*/
const pb1000 = require("./public/template/cookie-consent.css");

const jqueryUi = require("webpack-jquery-ui");
//const jqueryUiCSS = require("webpack-jquery-ui/css"); //ommit, if you don't want to load basic css theme
const jquery = require("jquery");
//const bootstrap = require("bootstrap");
//const slick = require("slick-carousel");
//const slickCSS = require("slick-carousel/slick/slick.css");
//const swipeCSS = require("photoswipe/dist/photoswipe.css");
//const swipeUI = require("photoswipe/dist/default-skin/default-skin.css");
//const jqueryMask = require("jquery-mask-plugin");
const pbCore = require("./public/apis/pb2020.core");
const pbUtil = require("./public/apis/manager/util");
window.jSmart = require("jsmart/dist/jsmart");
window.GI = require("gi-jsonrpc");

const skeleton = require("jquery.skeleton.loader");
